<script setup>

import {useFormField} from "../../../Registration/composables/useFormField";
import FieldErrorMessage from "../../../Registration/components/Fields/FieldErrorMessage.vue";

const emit = defineEmits(['blur', 'input']);

const {item, group, groupId, backend} = defineProps(['item','group','groupId', 'backend']);
const {model, uniqueItemId, path, inputAttributes, isReadOnly, getFieldClasses, createBlurHandler, createInputHandler} = useFormField(item, group, groupId, (v) => v, (v) => v, backend);

const handleBlur = createBlurHandler(emit);
const handleInput = createInputHandler(emit);

const className = getFieldClasses('w-full form-group form-wrapper form-checkbox-field');

const handleClick = (event) => {
    if (isReadOnly.value) {
        event.preventDefault();
        return false;
    }
};
</script>

<template>
    <div :class="className">
        <label :for="uniqueItemId" class="w-max max-w-full">
            <input data-form-type="other" type="checkbox"
                   v-model="model"
                   :id="uniqueItemId"
                   v-bind="inputAttributes"
                   @click="handleClick"
                   @blur="handleBlur"
                   @change="handleInput"
            >
            <span>
                <span v-html="item.label"></span>
                <span v-if="item.required && !isReadOnly"> *</span>
            </span>
        </label>
        <FieldErrorMessage :path="path" :backend="backend" />
    </div>
</template>

<style scoped>
.is-readonly {
    opacity: 0.5;
    pointer-events: none;
}

.is-readonly input[type="checkbox"] {
    cursor: not-allowed;
}
</style>
